import typography from "theme/base/typography";
import pxToRem from "theme/base/pxToRem";

const { size } = typography;

export const sizeLarge = {
  minHeight: pxToRem(46),
  padding: `${pxToRem(10)} ${pxToRem(24)}`,
  fontSize: size.md_16,

  "& .material-icon, .material-icons-round, svg": {
    fontSize: `${pxToRem(20)} !important`,
  },
};

export const sizeMedium = {
  minHeight: pxToRem(40),
  padding: `${pxToRem(8)} ${pxToRem(16)}`,
  fontSize: size.md_16,

  "& .material-icon, .material-icons-round, svg": {
    fontSize: `${pxToRem(20)} !important`,
  },
};

export const sizeSmall = {
  minHeight: pxToRem(32),
  padding: `${pxToRem(4)} ${pxToRem(16)}`,
  fontSize: size.xs_12,
  lineHeight: 1,
  "& .material-icon, .material-icons-round, svg": {
    fontSize: `${pxToRem(12)} !important`,
  },
};

